import React, { useEffect, useState } from "react";
import "./Venues.css";
import { Grid } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import BACKOFFICE_BASE_API_V1 from "../../utils/backofficeApi";
import { ensureOkResponse, handleApiFailureRedirect } from "../../utils/apiFailsafe";

const categories = [
  { id: "332c6a1c-fc3d-4a04-90a1-326014f81bc1", name: "Облека" },
  { id: "c9163180-8567-4c5a-b76a-6abc0b9f73ec", name: "Музика" },
  { id: "fcbca939-d505-489f-9b5c-630ea1f3e430", name: "Декорации" },
  { id: "647d5787-4fb6-499a-b5a1-4356b438c89a", name: "Фотографи" },
  { id: "0b7588f1-3e5c-47a5-9e7e-5e23f7cbf6a8", name: "Козметика" },
  { id: "d3f092e6-b1fa-4c89-b6ad-82cde08f9be1", name: "Ресторани" },
  { id: "15a858ea-2d38-4deb-9578-4139d3db6187", name: "Кетеринг/Торти" },
  { id: "5b52bd52-11ea-4b54-a964-6539368b4989", name: "Хотели" },
  { id: "2cbadf3a-6f10-40d8-b2bc-e45c838c6154", name: "Останато" },
];

function Venues() {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState(categories[0].id);
  const [venues, setVenues] = useState([]);

  useEffect(() => {
    let isMounted = true;

    const loadVenues = async () => {
      try {
        const response = await fetch(
          `${BACKOFFICE_BASE_API_V1}/venues?category_id=${activeCategory}&active=true`
        );
        ensureOkResponse(response);
        const data = await response.json();
        if (isMounted) {
          setVenues(Array.isArray(data) ? data : []);
        }
      } catch (error) {
        if (isMounted) {
          handleApiFailureRedirect(navigate, error);
        }
      }
    };

    loadVenues();

    return () => {
      isMounted = false;
    };
  }, [activeCategory, navigate]);

  return (
    <div className="venues-container venues-index-page">
      <div className="venues-index-header">
        <span className="venues-index-eyebrow">ПРОДАВНИЦИ</span>
        <h1 className="venues-index-title">Сите категории</h1>
        <p className="venues-index-subtitle">
          Пронајдете локации и услуги за вашиот ден, подредени по категории.
        </p>
      </div>

      <div className="tabs-container">
        {categories.map((category) => (
          <button
            key={category.id}
            className={`tab-button ${
              activeCategory === category.id ? "active" : ""
            }`}
            onClick={() => setActiveCategory(category.id)}
          >
            {category.name}
          </button>
        ))}
      </div>

      <Grid
        container
        className="venues-list"
        spacing={2}
        direction={{ xs: "column", sm: "row" }}
        justifyContent={{ xs: "center", md: "flex-start" }}
        alignItems="flex-start"
        sx={{
          flexWrap: "wrap",
          px: { xs: 2, sm: 4 },
        }}
      >
        {venues.length > 0 ? (
          venues.map((venue) => (
            <Grid item size={{ xs: 12, sm: 6, lg: 4 }} key={venue.id}>
              <Link to={`/venue/${venue.id}`} className="venue-card-link">
                <div className="venue-card">
                  <img
                    src={
                      venue.image_url ||
                      "https://placehold.co/600x400/weddings/white"
                    }
                    alt={venue.name}
                    className="venue-page-image"
                  />
                  <div className="venue-page-info">
                    <div className="venue-page-title-row">
                      <h3>{venue.name}</h3>
                      <span>{venue.city}</span>
                    </div>
                    <p>{venue.phone_number || "Контакт по договор"}</p>
                  </div>
                </div>
              </Link>
            </Grid>
          ))
        ) : (
          <Grid xs={12}>
            <div className="no-venues-message">
              Нема места во оваа категорија засега...
            </div>
          </Grid>
        )}
      </Grid>
    </div>
  );
}

export default Venues;
